module.exports = __webpack_public_path__ + "static/media/fx-page2-btn.2dc09d39.png";